import { Text } from '@dsx/react';
import styles from './ProductHighlights.module.scss';

interface ProductHighlightsProps {
	headline: string;
	subheadline?: string;
	bulletPoints: string[];
}

export function ProductHighlights({
	headline,
	subheadline,
	bulletPoints,
}: ProductHighlightsProps) {
	const hasContent = bulletPoints && bulletPoints.length > 0;

	return (
		<section className={styles.productHighlights}>
			<Text element="h2" variant="body-bold" className={styles.headline}>{headline}</Text>
			{subheadline && (
				<Text variant="body" className={styles.subheadline}>{subheadline}</Text>
			)}
			{hasContent ? (
				<ul className={styles.list}>
					{bulletPoints.map((point, index) => (
						<li key={index} className={styles.listItem}>
							<Text variant="body">{point}</Text>
						</li>
					))}
				</ul>
			) : (
				<Text variant="body" className={styles.noContent}>
					{headline} information is not available for this product.
				</Text>
			)}
		</section>
	);
}